import api from '../config';
import URLS from '../../constants/urls';
export const _getSupportedLanguages = () => {
    const response = api.get(`${URLS.SUPPORTED_LANGUAGES}`);
    return response;
};
export const _getSiteLanguages = (siteId) => {
    const response = api.get(`${URLS.SITE_LANGUAGES}/${siteId}`);
    return response;
};
export const _downloadExcelForLanguage = (siteId, multilingualId) => {
    return api.get(`${URLS.DOWNLOAD_LANGUAGE_EXCEL}/${siteId}/${multilingualId}/download-excel`, {
        responseType: 'blob',
        headers: {
            Accept: 'application/octet-stream',
        },
    });
};
export const _uploadExcelForLanguage = (siteId, multilingualId, data) => {
    const response = api.post(`${URLS.UPLOAD_LANGUAGE_EXCEL}/${siteId}/${multilingualId}`, data);
    return response;
};
